
import Vue from 'vue';
import datosPersonales from '@/components/perfil/DatosPersonales.vue';
import dispositivos from '@/components/perfil/Dispositivos.vue';
import vhero from '@/components/shared/VHero.vue';
import { mapState } from 'vuex';

export default Vue.extend({
  components: {
    datosPersonales,
    dispositivos,
    vhero,
  },
  beforeMount() {
    this.$http
      .get('Perfil', {
        headers: {
          Authorization: `Bearer ${this.jwt}`,
        },
      })
      .then((res) => {
        this.datos = res.data;
      });
  },
  data() {
    return {
      datos: '',
    };
  },
  computed: {
    ...mapState(['jwt']),
  },
});
